// extracted by mini-css-extract-plugin
export default {"noWrap":"X1PHE","ctaLink":"D+P7i"};